<template>
<div>
 
    <Breadcrumbs main="Ticket" title="Ticket Details" />
    <!-- Employee Details  -->
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-sm-12" v-if="!loading && !error">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                <div>
                                    <b-badge variant="info" class="mb-4">
                                        <h7 style="text-align: center;font-size: 14px;">Ticket Details</h7>
                                    </b-badge>
                                </div>
                                <div style="display: flex;">
                                    <feather type="message-circle" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-scrollable @click="Reply(ticket_detail)" title="Reply"></feather>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Created By</label>
                                        <input class="form-control" type="text" placeholder="Created By" v-model="ticket_detail.raised_by.username" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Ticket ID</label>
                                        <input class="form-control" type="text" placeholder="Enter grievance subject" v-model="ticket_detail.ticket_id" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Created Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="ticket_detail.created_date" disabled></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Ticket Details</label>
                                        <b-form-textarea id="textarea-auto-height" placeholder="Enter asset details..." v-model="ticket_detail.subject" rows="4" disabled></b-form-textarea>
                                    </div>
                                </div>
                            </div>

                            <div style="display: flex; flex-direction: row; gap: 12px;">
                                <h7 style="padding-top: 8px;">Ticket Status:</h7>
                                <div>
                                    <span @click="checkUserPermission('status',ticket_detail.status)" v-if="ticket_detail.status == 'CLOSED'">
                                        <b-button variant="danger"  v-b-tooltip.hover title="Update Status">
                                            <div style="display: flex; gap: 12px; align-items: center;">
                                                <h7>{{ ticket_detail.status }}</h7>
                                                <div style="padding-top: 3px;">
                                                    <feather type="edit" size="18px"></feather>
                                                </div>
                                            </div>
                                        </b-button>
                                    </span>
                                    <span @click="checkUserPermission('status',ticket_detail.status)" v-if="ticket_detail.status == 'OPEN'">
                                        <b-button variant="success"  v-b-tooltip.hover title="Update Status">
                                            <div style="display: flex; gap: 12px; align-items: center;">
                                                <h7>{{ ticket_detail.status }}</h7>
                                                <div style="padding-top: 3px;">
                                                    <feather type="edit" size="18px"></feather>
                                                </div>
                                            </div>
                                        </b-button>
                                    </span>
                                </div>
                            </div>

                            <div class="my-4" style="display: flex; flex-direction: row; gap: 12px;">
                                <h7 style="padding-top: 8px;">Ticket Priority:</h7>
                                <div>
                                    <span @click="checkUserPermission('priority',ticket_detail.priority)" v-if="ticket_detail.priority == 'LOW'">
                                        <b-button variant="info"  v-b-tooltip.hover title="Update Priority">
                                            <div style="display: flex; gap: 12px; align-items: center;">
                                                <h7>{{ ticket_detail.priority }}</h7>
                                                <div style="padding-top: 3px;">
                                                    <feather type="edit" size="18px"></feather>
                                                </div>
                                            </div>
                                        </b-button>
                                    </span>
                                    <span @click="checkUserPermission('priority',ticket_detail.priority)" v-if="ticket_detail.priority == 'MEDIUM'">
                                        <b-button variant="warning"  v-b-tooltip.hover title="Update Priority">
                                            <div style="display: flex; gap: 12px; align-items: center;">
                                                <h7>{{ ticket_detail.priority }}</h7>
                                                <div style="padding-top: 3px;">
                                                    <feather type="edit" size="18px"></feather>
                                                </div>
                                            </div>
                                        </b-button>
                                    </span>
                                    <span @click="checkUserPermission('priority',ticket_detail.priority)" v-if="ticket_detail.priority == 'HIGH'">
                                        <b-button variant="primary" v-b-tooltip.hover title="Update Priority">
                                            <div style="display: flex; gap: 12px; align-items: center;">
                                                <h7>{{ ticket_detail.priority }}</h7>
                                                <div style="padding-top: 3px;">
                                                    <feather type="edit" size="18px"></feather>
                                                </div>
                                            </div>
                                        </b-button>
                                    </span>
                                </div>
                            </div>

                            <h6 class="mt-4 mb-2">Already Refered</h6>
                            <div>
                                <div class="text-center" style="max-width: fit-content;" v-for="user in ticket_detail.refer_to" :key="user.id" v-b-tooltip.hover v-b-modal.modal-center-deleteAlocation @click="deletetAllocation(user.id)" title="Delete">
                                    <div style="background-color: #2c323f; padding: 6px 20px; color: white; border-radius: 4px; display: flex; gap: 12px;">
                                        <h7>{{ user.full_name}}</h7>
                                        <div style="padding-top: 1.5px;">
                                            <feather type="x" size="18px"></feather>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
            <div class="col-sm-12" v-else>
                <div class="loader-box">
                    <div class="loader-10"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- Update Status -->
    <b-modal id="modal-prevent-closing-status" ref="modal" title="Update Ticket Status" @show="resetModal" @hidden="resetModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Update Priority -->
    <b-modal id="modal-prevent-closing-priority" ref="modal" title="Update Ticket Priority" @show="resetModal" @hidden="resetModal" @ok="handlePriorityOk">
        <form ref="form" @submit.stop.prevent="handlePrioritySubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedPriority" :options="priorities"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Ticket Allocate Delete Modal -->
    <b-modal id="modal-center-deleteAlocation" centered hide-header @ok="handleAllocationDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to remove this refere?</div>
    </b-modal>

    <!-- Reply Modal -->
    <b-modal id="modal-scrollable" ref="modal" title="Ticket Reply" hide-footer @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <h6>Already Refered</h6>
        <div class="row">
            <div class="text-center col-sm-6 w-full" v-for="user in this.my_reply.refer_to" :key="user.id" v-b-tooltip.hover v-b-modal.modal-center-deleteAlocation @click="deletetAllocation(user.id)" title="Delete">
                <div class="w-100 mb-2 badge-style">
                    <h7>{{ user.first_name}}</h7>
                    <b-icon icon="x" style="color: white;"></b-icon>
                </div>
            </div>
        </div>
        <multiselect v-model="assignedMembers" tag-placeholder="Add member" placeholder="Search or add a member" label="first_name" :max="user_list.length" track-by="id" :options="user_list" :multiple="true" :taggable="true"></multiselect>
        <div style="margin-top: 30px;" v-if="ticket_reply.length>0">
            <h6>Replies</h6>
            <div class="task-board-comments">

                <div v-for="reply in ticket_reply" :key="reply.id" class="chatbox">
                    <div class="chat">
                        <div class="avatar">
                            <img :src="host + reply.replier_photo" alt="" v-b-tooltip.hover :title="reply.replied_by.first_name + ' ' + reply.replied_by.last_name">
                        </div>
                        <div class="message">
                            <h7 class="name pl-1">{{ reply.replied_by.username }}</h7>
                            <!-- <p class="msg" v-b-tooltip.hover :title="reply.reply_date">{{ reply.reply }}</p> -->
                            <p class="msg" v-html="convertUrls(reply.reply)"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-board-comment-box" style="margin-top: 10px;">
            <div style="display: flex; gap: 12px;">
                <input class="form-control" type="text" v-model="my_reply.reply" placeholder="Write your reply here..." @keyup.enter="handleReplySubmit()">
                <button @click="handleReplySubmit()" class="btn btn-primary">Send</button>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Multiselect from 'vue-multiselect';
import {
    myHost
} from '../../../../_helpers/host';
import {
    mapState
} from 'vuex';
import moment from "moment";
export default {
    components: {
        Datepicker,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selectedStatus: '',
            selectedPriority: '',

            my_reply: {
                id: '',
                reply: '',
                refer_to: '',
            },

            temp_id: '',
            statuses: ['OPEN', 'CLOSED'],
            priorities: ['HIGH', 'MEDIUM', 'LOW'],
            assignedMembers: [],
            filter: null,
            temp_id: '',
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            user: null,
        };
    },

    computed: {
        ...mapState({
            ticket_detail: state => state.ticket.ticket_details,
            user_list: state => state.employee.employee_list,
            ticket_reply: state => state.ticket.ticket_reply,
        }),
        // userName(){
        //     return this.ticket_detail.first_name + ' ' + this.ticket_detail.last_name
        // }
    },
    created() {
        this.user = JSON.parse(localStorage.getItem('user'))
    },

    mounted() {
        this.$store.dispatch("ticket/fetchTicketDetail", this.$route.params.id);
        this.$store.dispatch("employee/fetchEmployeeList");

    },
    watch: {
        assignedMembers: {
            handler: function (newVal, oldVal) {
                this.storeAssignedMembers(newVal);
            },
            deep: true
        }
    },

    methods: {
        checkUserPermission(type,status) {
            const currentUserId = this.user.user_object.id;

            const isMatched = this.ticket_detail.refer_to.some(
            (item) => item.id === currentUserId
            );

            if (isMatched) {
                if(type === 'status'){
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-prevent-closing-status')
                    })
                    this.getStatus(status)
                }
                else if(type === 'priority'){
                    this.$nextTick(() => {
                        this.$bvModal.show('modal-prevent-closing-priority')
                    })
                    this.getPriority(status)
                }
                
                
            } else {
                Swal.fire({
                    title: "Error!",
                    text: 'You do not have permission to access this.',
                    icon: "error"
                });

            }
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        convertUrls(text) {
            if (text === null) {
                return '';
            }

            const urlPattern = /(https?:\/\/[^\s<]+)/g;
            return text.replace(urlPattern, (url) => {
                return `<a href="${url}" target="_blank" class="text-primary">${url}</a>`;
            });
        },
        handleReplySubmit() {

            this.$store.dispatch("ticket/addTicketReply", {
                ticket: this.my_reply.id,
                reply: this.my_reply.reply
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.my_reply.id = '',
                        this.my_reply.reply = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },
        storeAssignedMembers(assignedMembers) {
            const latestId = assignedMembers[assignedMembers.length - 1].id;

            this.$store.dispatch("ticket/ticketAddRefer", {
                id: this.my_reply.id,
                refer_id: latestId,
                detail: true,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }

            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })

        },
        Reply(type) {
            this.my_reply.id = type.id
            this.my_reply.reply = type.name
            this.my_reply.refer_to = type.refer_to
            this.$store.dispatch("ticket/fetchTicketReply", this.my_reply.id)
        },
        deletetAllocation(id) {
            this.temp_id = id
        },
        handleAllocationDeleteOk() {
            this.$store.dispatch("ticket/ticketDeleteRefer", {
                id: this.$route.params.id,
                refer_id: this.temp_id,
                detail: true,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }

            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },
        getPriority(priority) {
            this.selectedPriority = priority
        },
        getStatus(status, id) {
            this.selectedStatus = status
        },
        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            this.$store.dispatch("ticket/updateTicketStatus", {
                id: this.$route.params.id,
                status_for_change: this.selectedStatus,
                from_details: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-status')
            })
        },
        handlePriorityOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handlePrioritySubmit()
        },

        handlePrioritySubmit() {
            this.$store.dispatch("ticket/updateTicketPriority", {
                id: this.$route.params.id,
                priority_for_change: this.selectedPriority,
                from_details: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-priority')
            })
        },
    }
};
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;

}

.badge-style:hover {
    background-color: #ff595d;
}

.chatbox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0px 10px;
}

.chat {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    word-break: break-all;
}

.avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: solid 2px white;
}

.message {
    flex-grow: 1;
}

.msg {
    background: #fff0f0;
    width: 100%;
    /* Ensures message takes full width */
    padding: 10px;
    border-radius: 10px;
    position: relative;
    font-size: 13px;
    word-break: break-all;
}

.task-board-comments {
    height: 450px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
